import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useEffect, useState } from 'react';
import { Button, Nav, Navbar, Offcanvas } from 'react-bootstrap';
import { FaBars, FaList, FaSignOutAlt } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import logo from './assets/images/Logo.avif';

const Sidebar = () => {
    const [showOffcanvas, setShowOffcanvas] = useState(false);
    const [accessPages, setAccessPages] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        try {
            const pages = JSON.parse(localStorage.getItem('accessPages')) || [];
            if (Array.isArray(pages)) {
                setAccessPages(pages);
            } else {
                setAccessPages([]);
            }
        } catch (err) {
            console.error("❌ Failed to parse accessPages from localStorage:", err);
            setAccessPages([]);
        }
    }, []);

    const handleToggle = () => setShowOffcanvas(!showOffcanvas);
    const handleClose = () => setShowOffcanvas(false);

    const handleLogout = () => {
        localStorage.clear();
        navigate('/login');
    };

    const offcanvasStyle = {
        width: '250px',
    };

    const menuItems = [
        { key: 'CreateUser', label: 'User List', path: '/CreateUser' },
        { key: 'Banner-list', label: 'Banner List', path: '/Banner-list' },
        { key: 'Section-list', label: 'Section List', path: '/Section-list' },
        { key: 'category-list', label: 'Category List', path: '/category-list' },
        { key: 'sub-category-list', label: 'Sub Category List', path: '/sub-category-list' },
        { key: 'product-list', label: 'Product List', path: '/product-list' },
        { key: 'discount-list', label: 'Discount List', path: '/discount-list' },
        { key: 'Video-list', label: 'Video List', path: '/Video-list' },
        { key: 'order-list', label: 'Order List', path: '/order-list' },
        { key: 'Shipment-list', label: 'Shipment List', path: '/Shipment-list' },
        { key: 'Contact-List', label: 'Contact List', path: '/Contact-List' },
        { key: 'SubcategoryOffer-List', label: 'Offer List', path: '/SubcategoryOffer-List' },
    ];

    return (
        <div>
            <Navbar style={{ backgroundColor: "#000000" }} variant="light" fixed="top">
                <div className="container-fluid">
                    <Button
                        style={{
                            backgroundColor: '#000000',
                            border: 'none',
                            padding: '9px',
                            borderRadius: '10px',
                        }}
                        onClick={handleToggle}
                        aria-controls="offcanvasNavbar"
                        aria-expanded={showOffcanvas}
                    >
                        <FaBars />
                    </Button>
                    <Navbar.Brand href="#">
                        <img src={logo} alt="Logo" style={{ height: '40px' }} />
                    </Navbar.Brand>
                </div>
            </Navbar>

            <Offcanvas
                show={showOffcanvas}
                onHide={handleClose}
                placement="start"
                className="bg-dark text-white"
                style={offcanvasStyle}
            >
                <img src={logo} alt="Logo" style={{ height: '160px', width: 'auto' }} />

                <Offcanvas.Body>
                    <Nav className="navbar-nav justify-content-end flex-grow-1 pe-3">
                        {menuItems.map((item) =>
                            accessPages.includes(item.key) && (
                                <Nav.Item key={item.key}>
                                    <Nav.Link href={item.path} className="text-white">
                                        <FaList className="me-2" /> {item.label}
                                    </Nav.Link>
                                </Nav.Item>
                            )
                        )}
                        <Nav.Item>
                            <Nav.Link onClick={handleLogout} className="text-white">
                                <FaSignOutAlt className="me-2" /> Logout
                            </Nav.Link>
                        </Nav.Item>
                    </Nav>
                </Offcanvas.Body>
            </Offcanvas>
        </div>
    );
};

export default Sidebar;
